// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/SeasonYearField.tsx
import { ChangeEvent, FunctionComponent } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputField } from '@/components/InputField';
import { SeasonFormData } from '../../schemas';
import { MAX_SEASON_YEAR, MIN_SEASON_YEAR } from '../../constants';

const PREFIX = 'pages.application_season.components.season_step1.fields.year';

export const SeasonYearField: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const value = watch('season_year') ?? '';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 4);
    setValue('season_year', digits, { shouldDirty: true, shouldValidate: true });
  };

  const handleBlur = () => {
    if (value.length < 4) return;
    const clamped = Math.min(Math.max(Number(value), MIN_SEASON_YEAR), MAX_SEASON_YEAR);
    setValue('season_year', String(clamped), { shouldValidate: true });
  };

  return (
    <Box>
      <InputField
        withoutFloating
        label={t(`${PREFIX}.label`)}
        inputMode="numeric"
        maxLength={4}
        textAlign="right"
        placeholder={t(`${PREFIX}.placeholder`)}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        rootProps={{
          isInvalid: !!errors.season_year,
          errorMessage: errors.season_year?.message,
        }}
      />
      <Text fontSize="13px" color="gray.500" mt={1}>
        {t(`${PREFIX}.help`)}
      </Text>
    </Box>
  );
};
